/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateUserDto
 */
export interface UpdateUserDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    familyname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    middlename?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    forename?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    username?: string | null;
}

export function UpdateUserDtoFromJSON(json: any): UpdateUserDto {
    return UpdateUserDtoFromJSONTyped(json, false);
}

export function UpdateUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'familyname': !exists(json, 'familyname') ? undefined : json['familyname'],
        'middlename': !exists(json, 'middlename') ? undefined : json['middlename'],
        'forename': !exists(json, 'forename') ? undefined : json['forename'],
        'username': !exists(json, 'username') ? undefined : json['username'],
    };
}

export function UpdateUserDtoToJSON(value?: UpdateUserDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'familyname': value.familyname,
        'middlename': value.middlename,
        'forename': value.forename,
        'username': value.username,
    };
}


